import React from 'react';
import Typography from '@material-ui/core/Typography';
import Box from '@material-ui/core/Box';
import Button from '@material-ui/core/Button';
import Tooltip from '@material-ui/core/Tooltip';
import clsx from 'clsx';

interface DayItem {
  dateTime: number;
  selected: boolean;
  title: string;
}

interface DayPickerProps {
  listControlDays: DayItem[];
  onDaySelect: (date: Date) => void;
  classes: Record<string, string>;
}

const DayPicker: React.FC<DayPickerProps> = ({
  listControlDays,
  onDaySelect,
  classes,
}) => (
  <Box className={classes.days}>
    {listControlDays.map((day) => {
      const classSelected = day.selected
        ? clsx(classes.dayContorl, classes.daySelected)
        : classes.dayContorl;
      return (
        <Tooltip key={day.dateTime} placement='top' title={day.title}>
          <Button
            onClick={() => onDaySelect(new Date(day.dateTime))}
            className={classSelected}>
            <Typography className={classes.responsiveText}>
              {day.title}
            </Typography>
          </Button>
        </Tooltip>
      );
    })}
  </Box>
);

export default DayPicker;
